// Apply only a contiguous sequence. A reconnect always starts with a snapshot.
export function createLiveState(){
 let state=null,sequence=0;
 const safe=k=>!['__proto__','prototype','constructor'].includes(k);
 function accept(frame){
  if(frame.type==='snapshot') {state=structuredClone(frame.state);sequence=frame.sequence;}
  else {
   if(!state||frame.type!=='patch'||frame.base!==sequence||frame.sequence!==sequence+1)throw Error('Live update sequence changed; resynchronizing');
   for(const change of frame.changes){
    if(!Array.isArray(change.path)||!change.path.length||!change.path.every(k=>typeof k==='string'&&safe(k)))throw Error('Invalid update path');
    let target=state;for(const key of change.path.slice(0,-1)){if(!Object.hasOwn(target,key)||!target[key]||typeof target[key]!=='object')throw Error('Missing update parent');target=target[key];}
    const key=change.path.at(-1);if(change.op==='remove')delete target[key];else if(change.op==='set')target[key]=structuredClone(change.value);else throw Error('Invalid update operation');
   }sequence=frame.sequence;
  }
  const board=state.board||{};
  return {...state,calls:Object.values(state.calls||{}),queues:Object.values(state.queues||{}).map(q=>({...q,members:Object.values(q.members||{}),waiting:Object.values(q.waiting||{})})),board:{...board,endpoints:Object.values(board.endpoints||{}),channels:Object.values(board.channels||{})}};
 }
 return {accept};
}

// Preserve tile identity, focus, media elements, scrolling and user geometry.
export function patchDOM(root,html){
 const template=root.ownerDocument.createElement('template');if(typeof html==='string')template.innerHTML=html;else template.content.append(html);
 const key=n=>n.nodeType===1?(n.id?'id:'+n.id:n.dataset.layoutRegion?'region:'+n.dataset.layoutRegion:n.dataset.panelId?'panel:'+n.dataset.panelId:n.dataset.layoutKey?'tile:'+n.dataset.layoutKey:n.dataset.boardSection?'section:'+n.dataset.boardSection:n.dataset.queue&&n.tagName==='ARTICLE'?'queue:'+n.dataset.queue:n.dataset.liveKey?'live:'+n.dataset.liveKey:''):'';
 const compatible=(a,b)=>a?.nodeType===b.nodeType&&(a.nodeType!==1||a.tagName===b.tagName)&&key(a)===key(b);
 function update(a,b){
  if(a.nodeType===3){if(a.nodeValue!==b.nodeValue)a.nodeValue=b.nodeValue;return;}
  if(a.nodeType!==1)return;
  if(a.matches('.sidebar,audio,video,[data-live-preserve],.layout-grip,.layout-resize,#layout-toolbar'))return;
  const focused=a===a.ownerDocument.activeElement;
  const geometry=a.hasAttribute('data-layout-key')||a.hasAttribute('data-board-section')||a.hasAttribute('data-panel-id');
  for(const attr of [...a.attributes])if(!b.hasAttribute(attr.name)&&!(geometry&&/^(style|data-layout)/.test(attr.name))&&!(a.tagName==='DETAILS'&&attr.name==='open'))a.removeAttribute(attr.name);
  for(const attr of [...b.attributes])if(a.getAttribute(attr.name)!==attr.value&&!(geometry&&attr.name==='style')&&!(a.tagName==='DETAILS'&&attr.name==='open')&&!(focused&&attr.name==='value'))a.setAttribute(attr.name,attr.value);
  if(a.matches('input,textarea,select')){if(focused)return;if(a.tagName!=='SELECT'){if(a.value!==b.value)a.value=b.value;return;}}
  children(a,b);
  if(a.tagName==='SELECT'&&!focused)a.value=b.value;
 }
 function children(a,b){
  const existing=new Map([...a.childNodes].filter(n=>key(n)).map(n=>[key(n),n]));let cursor=a.firstChild;
  for(const fresh of [...b.childNodes]){
   let node=key(fresh)?existing.get(key(fresh)):cursor;
   if(!compatible(node,fresh)){node=fresh;a.insertBefore(node,cursor);}
   else {if(node!==cursor)a.insertBefore(node,cursor);update(node,fresh);}
   cursor=node.nextSibling;
  }
  while(cursor){const next=cursor.nextSibling;if(!(cursor.nodeType===1&&cursor.matches('.layout-grip,.tile-resize')))cursor.remove();cursor=next;}
 }
 children(root,template.content);
}
